<script>
import CustomerCustomFieldsModal from '@school/components/CustomerCustomFieldsModal.vue';

export default {
  components: { CustomerCustomFieldsModal },
  props: {
    training: { type: Object, default: null },
  },
  data: () => ({ active: false }),
  computed: {
    authCustomer() {
      // No prompt in preview mode.
      return this.$route.query.p ? null : this.$store.getters['auth/customer'];
    },
    guessedCustomerTraining() {
      if (!this.authCustomer || !this.training) return null;
      return this.authCustomer.customer_trainings
        .find((t) => t.uuid === this.training.uuid);
    },
    fields() {
      const opts = this.training && this.training.custom_fields_options;
      return (opts && opts.enabled && opts.fields) || [];
    },
    initialAnswers() {
      const ct = this.guessedCustomerTraining;
      return (ct && ct.custom_fields_data && ct.custom_fields_data.answers) || [];
    },
    needs() {
      if (!this.authCustomer || !this.training || !this.fields.length) {
        return false;
      }
      // While navigating to another training, the Vuex `current` still holds the
      // previous one until the new fetch resolves — don't prompt for a stale
      // training whose slug no longer matches the route (avoids the old popup
      // flashing before the new one).
      if (this.$route.params.slug && this.training.slug
        && this.training.slug !== this.$route.params.slug) {
        return false;
      }
      const ct = this.guessedCustomerTraining;
      const configuredAt = this.training.custom_fields_options
        && this.training.custom_fields_options.configured_at;
      // Only new learners (enrolled on/after the fields were configured).
      if (configuredAt && (!(ct && ct.enrolled_at) || ct.enrolled_at < configuredAt)) {
        return false;
      }
      const cf = (ct && ct.custom_fields_data) || {};
      const answers = Array.isArray(cf.answers) ? cf.answers : [];
      // Engaged once (answered or dismissed) => never prompt again.
      if (answers.length > 0 || cf.dismissed_at) {
        return false;
      }
      return true;
    },
  },
  watch: {
    needs: {
      immediate: true,
      handler(needs) {
        // Mirror needs: opens for the current training, and closes immediately
        // when switching trainings (stale slug) or once answered/dismissed.
        this.active = needs;
      },
    },
  },
  methods: {
    onSubmitted() {
      this.active = false;
      this.$store.dispatch('auth/fetch').catch(() => {});
    },
    onDismissed() {
      this.active = false;
      this.$store
        .dispatch('trainings/dismissCustomFieldAnswers', { slug: this.training.slug })
        .then(() => this.$store.dispatch('auth/fetch'))
        .catch(() => {});
    },
  },
};
</script>

<template>
  <CustomerCustomFieldsModal
    v-if="training && authCustomer"
    :active="active"
    :fields="fields"
    :initial-answers="initialAnswers"
    submit-action="trainings/submitCustomFieldAnswers"
    :submit-payload="{ slug: training.slug }"
    @close="active = false"
    @dismiss="onDismissed"
    @submitted="onSubmitted"
  />
</template>
